import { Switch as SwitchPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

import { cn } from './cn';

export type SwitchProps = ComponentProps<typeof SwitchPrimitive.Root> & { readonly readOnly?: boolean };

/** Liga/desliga com efeito imediato (Radix Switch). Para escolha que só vale ao salvar, prefira Checkbox. */
export function Switch({ className, readOnly, disabled, ...props }: SwitchProps) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      disabled={disabled === true || readOnly === true}
      className={cn(
        'peer relative inline-flex h-5 w-[34px] shrink-0 items-center rounded-full border border-input bg-muted',
        'transition-colors duration-(--lume-dur-fast) ease-out',
        'data-[state=checked]:border-primary data-[state=checked]:bg-primary',
        'disabled:cursor-not-allowed disabled:opacity-45 aria-invalid:border-error',
        'after:absolute after:-inset-3.5 md:after:-inset-2',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          'pointer-events-none block size-3.5 translate-x-[2px] rounded-full bg-card shadow-1',
          'transition-transform duration-(--lume-dur-fast) ease-out',
          'data-[state=checked]:translate-x-[16px] data-[state=checked]:bg-thumb',
        )}
      />
    </SwitchPrimitive.Root>
  );
}
